var exports = {
  "Fr": "xaee3c4fa--514a90--survey",
  "d8": "xaee3c4fa--514a90--survey__title",
  "ry": "xaee3c4fa--514a90--survey__title_result",
  "Hn": "xaee3c4fa--514a90--survey__options",
  "a8": "xaee3c4fa--514a90--survey__quantity",
  "P0": "xaee3c4fa--514a90--survey__input",
  "St": "xaee3c4fa--514a90--survey__option-wrapper",
  "mi": "xaee3c4fa--514a90--survey__option",
  "kX": "xaee3c4fa--514a90--survey__option_result",
  "FK": "xaee3c4fa--514a90--survey__option_multiple",
  "d": "xaee3c4fa--514a90--survey__button",
  "Xb": "xaee3c4fa--514a90--survey__emoji",
  "Cq": "xaee3c4fa--514a90--survey__option-bg",
  "C8": "xaee3c4fa--514a90--survey__option-text",
  "WJ": "xaee3c4fa--514a90--isChecked",
  "Mm": "xaee3c4fa--514a90--survey__percent",
};

module.exports = exports;
